import React, { useState } from "react";
import { formatDate } from "../helpers/utilities";
import { useSelector } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, InputAdornment, TextField } from "@mui/material";
import './centralPatientFeedback.css'

export const CentralPatientFeedback = () => {
    const [isEdit, setIsEdit] = useState(false)
    const [editedMobile, setEditedMobile] = useState('');
    const reportingData = useSelector(state => state.centralReportingData?.reportingData);
    const patientFeedback = reportingData?.data ? reportingData?.data[0]?.patientFeedback : {}
    
    const handleEditIcon = () =>{
        setIsEdit(true)
    }

    const handleCloseEdit = () => {
        setEditedMobile('')
        setIsEdit(false);
    };

    const handleOnChange = (e) => {
      const value = e.target.value;
      if(/^\d{0,10}$/.test(value)) {
        setEditedMobile(value);
      }
    }

  return (
    <div>
      <div className="textReadOnlyRow">
        <span className="textReadOnlyLabel">Patient Number</span>
        <div className="feedbackMobileEditContainer">
            <span className="textReadOnlyValue">{patientFeedback.maskMobile || '--'}</span>
        </div>
        {/* {!isEdit ? <div className="feedbackMobileEditContainer">
            <span className="textReadOnlyValue">{patientFeedback.maskMobile || '--'}</span>
            <EditIcon fontSize="small" sx={{ color: "#3476CD" , fontSize:'15px'}} onClick={handleEditIcon}/>
        </div> :
        <TextField
        size="small"
        value={editedMobile}
        onChange={handleOnChange}
        variant="outlined"
        placeholder="Mobile"
        inputProps={{
          maxLength: 10,
          inputMode: 'number',
          pattern: '[0-9]*'
        }}
        sx={{
          height: '30px',
          width:'155px',
          '& .MuiInputBase-root': {
            height: '30px',
            fontSize: '12px',
            paddingRight:'2px',
            paddingLeft:'8px'
          },
          '& input': {
            padding: '0',
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <span style={{ fontSize: '12px' }}>+91</span>
            </InputAdornment>
          ),
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton onClick={handleCloseEdit} size="small">
                        <CloseIcon fontSize="small" sx={{color:'#3476CD'}}/>
                    </IconButton>
                </InputAdornment>
            )
        }}
    />
    } */}
      </div>
      <div className="textReadOnlyRow">
        <span className="textReadOnlyLabel">SubStatus</span>
        <span className="textReadOnlyValue">{patientFeedback.subStatus || '--'}</span>
      </div>
      <div className="textReadOnlyRow">
        <span className="textReadOnlyLabel">Trigger Time</span>
        <span className="textReadOnlyValue">{formatDate(patientFeedback.triggerTime ,"DD MMM, hh:mm A")}</span>
      </div>
      <div className="textReadOnlyRow">
        <span className="textReadOnlyLabel">Source</span>
        <span className="textReadOnlyValue">{patientFeedback.source || '--'}</span>
      </div>
      <div className="textReadOnlyRow">
        <span className="textReadOnlyLabel">Received At</span>
        <span className="textReadOnlyValue">{formatDate(patientFeedback.receivedAt ,"DD MMM, hh:mm A")}</span>
      </div>
      <div className="textReadOnlyRow">
        <span className="textReadOnlyLabel">Patient Type</span>
        <span className="textReadOnlyValue">{patientFeedback.patientType || '--'}</span>
      </div>
    </div>
  );
};
